import * as Sentry from "@sentry/nextjs";

import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'
// import Link from 'next/link'

import type { Item } from '@/modules/board'

import { Util, EiaHandler } from '@/modules/fileManager';
import FileList from '@/modules/fileManager/listTheme/default';

import { getPrevRouterHistory } from '@/modules/nextjs/routerHistory.csr'
import TuiViewer from '@/components/editor/tuiViewer'

import Dayjs from '@/components/dayjs'
import Button from '@/components/button/GGButton'

import style from './item.module.css'

interface IProps {
  boardTitle: string;
  boardCategory: string;
  query: string;
  item: Item;
}

const Component: NextPage<IProps> = ({ boardTitle, boardCategory, query, item }) => {
  const Router = useRouter();

  const download = useCallback((id) => {
    document.location = `${process.env.NEXT_PUBLIC_API_URL}/api/file/download/${id}`;
  }, [])

  // useEffect(() => {
  //   const viewer = new Viewer();
  //   {
  //     el: document.querySelector('#viewer'),
  //     initialValue: item.content
  //   });
  // }, [item])

  const goList = useCallback(() => {
    try {
      const prev = getPrevRouterHistory();
      if (prev && ['/', '/board/[category]/[idx]'].includes(prev.route)) {
        Router.push(`/board/${boardCategory}`)
      } else {
        Router.back();
      }
    } catch(err) {
      Sentry.captureMessage("sessionStorage.getItem('prevPath') error");
      Sentry.captureException(err);
      Router.back();
    }
  }, [Router, boardCategory]);

  return (
    <div className='flex flex-col items-center'>
      <div className='w-[1200px] min-w-[1200px] max-w-[1200px] flex flex-col items-center justify-center my-16'>
        <div className='w-full'>
          <h1 className={`${style.h1} pb-6 border-b-2 border-b-[#111111]`}>{boardTitle}</h1>

          <section>
            <div>
              <table className={style.thInTbodyTable}>
                <colgroup>
                  <col width={200}/>
                  <col width={400}/>
                  <col width={200}/>
                  <col width={400}/>
                </colgroup>
                <tbody>
                  <tr>
                    <th>제목</th>
                    <td colSpan={3}>{item.title}</td>
                  </tr>
                  <tr>
                    <th>내용</th>
                    <td colSpan={3}>
                      <div className='w-full min-h-[400px] max-h-[600px] overflow-y-auto pt-6 pb-6'>
                        <TuiViewer initialValue={item.content} />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>등록일</th>
                    <td><Dayjs format="dateDot">{item.createdAt}</Dayjs></td>
                    <th>작성자</th>
                    <td>{item.createdManager}</td>
                  </tr>
                  {/* {item.files.length > 0 && ( */}
                  <tr>
                    <th>첨부파일</th>
                    <td colSpan={3}>
                      <div className='flex items-center justify-between'>
                        <div className="my-4">
                          {/* {item.files.length > 1 && ( */}
                          {/*  <button className='rounded bg-[#009BFA] text-[16px] text-white font-light min-w-[90px] min-h-[32px]'>*/}
                          {/*    모두저장*/}
                          {/*  </button>*/}
                          {/* )} */}
                        </div>
                        <div>
                          {/* {item.files.length > 0 && ( */}
                            <span className='text-[16px] text-[#666666] font-light'>총 첨부파일 <span className='text-[#009BFA]'>{item.files.length}</span>개 ({Util.getFileSizeToString(item.files.reduce((acc, file) => acc + file.size, 0))})</span>
                          {/* )} */}
                        </div>
                      </div>
                      <div className="my-4 space-y-1">
                        <FileList
                          items={[]}
                          existingItems={item.files}
                          downloadHandler={EiaHandler.download}
                        />
                      </div>
                    </td>
                  </tr>
                  {/* )} */}
                </tbody>
              </table>
            </div>
          </section>

          <div className='my-16 text-center'>
            <Button className='w-[180px] h-[60px]' onClick={() => goList()}>목록으로</Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
